import { render } from "./carThirdPartySharing.vue?vue&type=template&id=39d61648"
const script = {}

import "./carThirdPartySharing.vue?vue&type=style&index=0&id=39d61648&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__